import React from 'react';
import axios from 'axios';
import axiosUrl from '../../axios/url';


// 프로젝트 생성 다이얼로그
export default function ProejctCreateDialog(param) {
    const [name, setName] = React.useState('');

    // handler
    function onChangePorjectName(e){ setName(e.target.value);}

    function trim(stringToTrim) {
        return stringToTrim.replace(/^\s+|\s+$/g,"");
    }
    // 프로젝트 생성
    async function saveProject(){
        if(trim(name) === '') { alert('프로젝트 이름을 확인하세요.'); return; }
        //if(!window.confirm('프로젝트를 추가하시겠습니까?')) return;
        
        await axios.post(axiosUrl.project ,{
            name: name,
        })
        .then(function (response){
            param.callbackUpdateList();
            document.getElementById('projectCreateClose').click();
        })
        .catch(function (e) {
            alert('프로젝트 추가에 실패했습니다. 다시 시도하세요.');
                console.error('[MEDIEX_CMS_2019_ERROR] ProjectCreateDialo.saveProject - ' + e.response.data.error.message);
        });

    }


    return(
        <div className="modal fade" id="ProjectCreateDialog" data-keyboard="false" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
            <div className="modal-dialog   modal-dialog-centered" role="document">
                <div className="modal-content">
                <div className="modal-header contentColor">
                    <h5 className="modal-title" id="exampleModalLabel">프로젝트 추가하기</h5>
                    <button type="button" id="projectCreateClose" className="close" data-dismiss="modal" onClick={() => setName('')} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                 <input type="text" className="form-control" value={name}  onChange={onChangePorjectName} />
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => setName('')} >닫기</button>
                    <button type="button" className="btn btn-primary" onClick={saveProject} >저장</button>
                </div>
                </div>
            </div>
            </div>
    );
}